import { confirmDialog } from 'primereact/confirmdialog';

const BaseDialogConfirmMethod = confirmDialog;

export default BaseDialogConfirmMethod;